module.exports = __webpack_public_path__ + "img/data@2x.5cd3ec6d.png";